import React from 'react';

export default function SuggestedActionDescription({rec, template}) {
  // All these because firstName can be null theoretically
  const firstNameSubjective = rec.firstName ? `${rec.firstName} is` : 'they are';
  const firstNameSubjectiveDo = rec.firstName ? `${rec.firstName} does` : 'they do';
  const firstNameObjective = rec.firstName ? rec.firstName : 'them';
  const firstNamePossessive = rec.firstName ? `${rec.firstName}'s` : 'their';
  const params = {
    ...rec,
    firstNameSubjective,
    firstNameSubjectiveDo,
    firstNameObjective,
    firstNamePossessive,
  };
  // All descriptions start with the manager's display name, so this works,
  // in general, will need a more elegant solution
  return (
    <div className="action-description">
      <span id="manager-name" className="generic-link">
        {rec.displayName}
        {template.teamPossessive ? "'s" : ''}
      </span>
      {template.description(params)}
    </div>
  );
}
